import React from 'react';
//@ts-ignore
import { tw } from '@careinfo/tailwind';
import moment from 'moment';
import ReplyIcon from '../../../Icons/ReplyIcon';

const RecursiveComment = ({ item, setComment }: any) => {
  return (
    <div className={tw` py-1 text-base bg-white border-t border-gray-200 `}>
      <div className={tw`flex  items-center w-full`}>
        <div className={tw`flex items-start justify-between w-full`}>
          <div className={tw`flex items-start justify-start gap-x-2`}>
            <div
              className={tw`h-8 w-8 md:h-10 md:w-10 rounded-full mt-2 bg-gray-400 items-center justify-center flex`}
            >
              <p className={tw`text-lg md:text-2xl text-text-primary`}>
                {item?.user?.name?.slice(0, 1)}
              </p>
            </div>
            <div>
              <div className='flex items-center gap-x-1 text-sm text-[#787878]'>
                <p className={tw`items-center`}>{item?.user.name}</p>
                <p className={tw`text-xl text-text-primary`}>&bull;</p>
                <p className={tw`text-[10px]`}>{item?.branch}</p>
              </div>
              <p className={tw`text-base ml-2 text-justify w-[270px]`}>
                {item?.comment}
              </p>
            </div>
          </div>
          <div className={tw`flex gap-x-2 items-center`}>
            <div className={tw`text-xs font-monospace text-gray-600 mt-1`}>
              <p>{moment(item?.created).format('YYYY-MM-DD')}</p>
              <p>{moment(item?.created).format('hh:mm:ss A')}</p>
            </div>
            <button
              type='button'
              onClick={() => setComment(item)}
              className={tw`focus:outline-none`}
            >
              <ReplyIcon />
            </button>
          </div>
        </div>
      </div>
      {/* <div
        className={tw`ml-auto`}
        style={{
          width: "fit-content",
        }}
      >
        <button
          type="button"
          onClick={() => setComment(item)}
          className={tw`focus:outline-none`}
        >
          <ReplyIcon />
        </button>
      </div> */}
      {item?.children && item?.children.length > 0 && (
        <div className={tw`ml-4 mt-1 flex `}>
          <div className={tw`border-l-2 border-gray-300 mr-4`}></div>
          <div className={tw`w-full`}>
            {item?.children?.map((child) => (
              <RecursiveComment
                key={child.id}
                item={child}
                setComment={setComment}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default RecursiveComment;
